import { forwardRef, type SelectHTMLAttributes } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/cn";

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: { value: string; label: string }[];
  /** Default true: siehe Input.tsx — in Filterleisten auf false setzen und Breite via
   * `className` (z. B. "w-44") vorgeben, sonst bricht jedes Select in eine eigene Zeile um. */
  fullWidth?: boolean;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  function Select(
    { className, label, options, id, fullWidth = true, ...props },
    ref,
  ) {
    const sid = id ?? props.name;
    return (
      <div className={fullWidth ? "w-full" : "shrink-0"}>
        {label && (
          <label htmlFor={sid} className="label">
            {label}
          </label>
        )}
        <div className="relative">
          <select
            ref={ref}
            id={sid}
            className={cn(
              "appearance-none bg-bg-input border border-border rounded pl-3 pr-8 py-2 text-sm text-text-primary",
              "focus:border-border-accent focus:ring-1 focus:ring-accent/30",
              fullWidth && "w-full",
              className,
            )}
            {...props}
          >
            {options.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
          <ChevronDown className="w-4 h-4 text-text-tertiary absolute right-2.5 top-1/2 -translate-y-1/2 pointer-events-none" />
        </div>
      </div>
    );
  },
);
